export { InfoContentIcon } from './InfoContentIcon';
